export enum LoadingState {
  DONE,
  BUSY
}
